import Reveal from "./Reveal";
import { SITE, whatsappLink } from "@/constants/site";

export default function Location() {
  const waLink = whatsappLink(
    "Merhaba Düzbağ Life, konum ve ulaşım hakkında bilgi almak istiyorum."
  );

  return (
    <section id="konum" className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text */}
          <Reveal>
            <span className="text-secondary-600 text-xs tracking-[0.3em] uppercase">
              Konum
            </span>
            <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.15] font-medium">
              DOĞANIN KALBİNDE
            </h2>
            <div className="mt-6 h-px w-16 bg-accent-500" />
            <p className="mt-6 text-foreground-700 text-base md:text-lg leading-relaxed">
              Yeşilin ve dağların ortasında, gürültüden uzak bir konum. Düzbağ
              Life, Çağlayancerit'in doğal dokusu içinde sizi bekliyor.
            </p>

            <div className="mt-8 flex items-start gap-4">
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                <i className="ri-map-pin-line text-xl" />
              </span>
              <div>
                <p className="text-foreground-950 font-medium">{SITE.addressLine1}</p>
                <p className="text-foreground-600 text-sm mt-0.5">{SITE.addressLine2}</p>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href={SITE.mapsDirections}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold px-6 py-3.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-route-line text-lg" />
                Yol Tarifi Al
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border border-foreground-300 text-foreground-800 font-semibold px-6 py-3.5 rounded-md whitespace-nowrap transition-colors hover:bg-background-200 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg" />
                WhatsApp'tan Konum İste
              </a>
            </div>
          </Reveal>

          {/* Map */}
          <Reveal delay={120}>
            <div className="w-full h-[340px] md:h-[440px] rounded-lg overflow-hidden border border-background-300/60">
              <iframe
                title="Düzbağ Life konum haritası"
                src={SITE.mapsEmbed}
                className="w-full h-full"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}